function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("mask", {
  id: "mask0",
  "mask-type": "alpha",
  maskUnits: "userSpaceOnUse",
  x: 0,
  y: 0,
  width: 60,
  height: 60
}, React.createElement("circle", {
  cx: 30,
  cy: 30,
  r: 15,
  stroke: "black",
  strokeWidth: 30
}));

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  mask: "url(#mask0)"
}, React.createElement("g", {
  opacity: 0.636
}, React.createElement("path", {
  d: "M31.712 56C44.73 56 56.83 38.018 56.83 25C56.83 11.982 38.15 5 25.133 5C12.115 5 3 15.982 3 29C3 42.018 18.694 56 31.712 56Z",
  stroke: "#00C1F1"
}), React.createElement("path", {
  d: "M29.342 54.667C16.324 54.667 6.612 38.221 6.612 25.204C6.612 12.186 16.324 7.525 29.342 7.525C42.36 7.525 54 12.185 54 25.204C54 38.221 42.36 54.667 29.342 54.667Z",
  stroke: "#00C1F1"
})));

var Svg1 = function Svg1(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(Svg1, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/1.c9b30c8b.svg";
export { ForwardRef as ReactComponent };